const TeamRecord = ({sport, teamName, record, opponentRecord, seriesRecord, opponentSeriesRecord, tournamentName, className}) =>{

    return(
        <div className={className}>
                  <h2>{teamName}</h2>
                  <p>{tournamentName === sport && `(${record.wins}-${record.losses})`}</p>
                  <p>{tournamentName === `${sport}, Playoffs` && `(${seriesRecord}-${opponentSeriesRecord})` }</p>
                </div>  
    )
}

export default TeamRecord;